import httpClient from 'core/api/httpClient'
import { API_URL } from 'core/constants'
import { FilterState } from 'core/contexts/FilterContext'
import { makeDateConsumableForApi } from 'core/utils/api'

export async function analyzeDashboard(
  filters: FilterState,
  zoneOffsetMinutes: number
): Promise<string> {
  const body = {
    fromTime: makeDateConsumableForApi(filters.dateFrom),
    toTime: makeDateConsumableForApi(filters.dateTo),
    ...(filters.symbols.length > 0 && { instrumentAliases: filters.symbols }),
    ...(filters.journalId != null && { journalIds: [filters.journalId] }),
    zoneOffset: zoneOffsetMinutes,
  }
  const response = await httpClient.post(`${API_URL}/api/dashboard/ai/analyze`, body)
  return response.data.result.analysis as string
}
